import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import {
  organisationTabCriteria,
  boundariesCriteria,
} from '../../../utilities/epic-helpers';

import {
  boundariesSet,
  concatenateBoundariesByname,
} from '../../../utilities/helpers';

import saveAs from 'file-saver';
import moment from 'moment';

import {
  DOWNLOAD_MOBILE_DEVICES_INSIGHTS,
  DOWNLOAD_MOBILE_DEVICES_INSIGHTS_SUCCESS,
  DOWNLOAD_MOBILE_DEVICES_INSIGHTS_FAILURE,
} from '../../constants';

const downloadMobileDevices = (action$, state$) =>
  action$.pipe(
    ofType(DOWNLOAD_MOBILE_DEVICES_INSIGHTS),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.server}/report/mobile-devices/${
          action.csvType
        }/download?${organisationTabCriteria(state$)}${boundariesCriteria(
          state$
        )}&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'text',
        crossDomain: true,
      }).pipe(
        map(response => {
          const blob = new Blob([`${response.response}`], { type: 'text/csv' });
          const fileName = `LANDMARKSID_${action.reportType}_${
            action.fileName
          }_${
            boundariesSet(state$.value.insightsCriteria.adm0) === true
              ? `${concatenateBoundariesByname(
                  state$.value.insightsCriteria.adm0
                )}`
              : ''
          }${
            boundariesSet(state$.value.insightsCriteria.adm1) === true
              ? `${concatenateBoundariesByname(
                  state$.value.insightsCriteria.adm1
                )}`
              : ''
          }${
            boundariesSet(state$.value.insightsCriteria.adm2) === true
              ? `${concatenateBoundariesByname(
                  state$.value.insightsCriteria.adm2
                )}`
              : ''
          }${
            boundariesSet(state$.value.insightsCriteria.adm3) === true
              ? `${concatenateBoundariesByname(
                  state$.value.insightsCriteria.adm3
                )}`
              : ''
          }${
            boundariesSet(state$.value.insightsCriteria.adm4) === true
              ? `${concatenateBoundariesByname(
                  state$.value.insightsCriteria.adm4
                )}`
              : ''
          }_${moment(new Date()).format('DD/MM/YYYY')}.csv`;

          saveAs(blob, fileName);
          return {
            type: DOWNLOAD_MOBILE_DEVICES_INSIGHTS_SUCCESS,
          };
        }),
        catchError(error =>
          of({
            type: DOWNLOAD_MOBILE_DEVICES_INSIGHTS_FAILURE,
            error,
          })
        )
      )
    )
  );

export default downloadMobileDevices;
